class Menu {

	constructor() {
		this.search();
		this.mobile();
		this.desktop();
	}

	search(){
		( function( $ ) {
			$('.toggle-search').on('click', function(e){
				$('#site-header').toggleClass('search');
			});
		}( jQuery ) );
	}

	desktop() {
		( function( $ ) {
			$(window).resize(function(){
	      dropdownAttrHandler();
	    });

	    dropdownAttrHandler();

	    function dropdownAttrHandler(){
	      if($(window).width() < 992){
	        $('.dropdown-toggle').attr('data-toggle', 'dropdown');
	      }else{
	        $('.dropdown-toggle').removeAttr('data-toggle');
	      }
	    }
		}( jQuery ) );
	}

	mobile(){
		( function( $ ) {
			$(document).on('click', '#mobile-menu li.dropdown', function(e){
				let menu_title = $(this).find(">:first-child").clone(),
						menu = $(this).find("ul").html();

				$('#mobile-menu-expanded-first-lvl .menu-title').html($(menu_title).removeAttr('data-toggle'));
				$('#mobile-menu-expanded-first-lvl .mobile-menu-lvl').html(menu);
				$('#mobile-menu-expanded-first-lvl, #mobile-menu-expanded').removeClass('hidden');

				$('header#site-header').append('<div id="mobile-menu-expanded-back"></div>')
			});

			$(document).on('click', '#mobile-menu li.dropdown > a', function(e){
				let menu_title = $(this).parent().find(">:first-child").clone(),
						menu = $(this).parent().find("ul").html();

				$('#mobile-menu-expanded-first-lvl .menu-title').html($(menu_title).removeAttr('data-toggle'));
				$('#mobile-menu-expanded-first-lvl .mobile-menu-lvl').html(menu);
				$('#mobile-menu-expanded-first-lvl, #mobile-menu-expanded').removeClass('hidden');

				$('header#site-header').append('<div id="mobile-menu-expanded-back"></div>')
			});

			$(document).on('click', '#mobile-menu-expanded-first-lvl li.dropdown', function(e){
				let menu_title = $(this).find(">:first-child").clone(),
						menu = $(this).find("ul").html();

				$('#mobile-menu-expanded-second-lvl .menu-title').html($(menu_title).removeAttr('data-toggle'));
				$('#mobile-menu-expanded-second-lvl .mobile-menu-lvl').html(menu);
				$('#mobile-menu-expanded-second-lvl, #mobile-menu-expanded-second').removeClass('hidden');
			});

			$(document).on('click', '#mobile-menu-expanded-back', function(e){
				if(!$('#mobile-menu-expanded-second').hasClass('hidden')){
					$('#mobile-menu-expanded-second').addClass('hidden');
				}else{
					$('#mobile-menu-expanded').toggleClass('hidden');
					$('#mobile-menu-expanded-back').remove()
				}
			});


			$('.toggle-mobile-menu').on('click', function(){
				$('body').toggleClass('overflow-hidden');
				$('body').toggleClass('mobile-menu-open');
			});

			$('.toggle-mobile-menu.open').on('click', function(){
				$('#menu-upper-lvl').removeClass('hidden');
	      $('#mobile-navigation-container').removeClass('hidden');
			});

			$('.toggle-mobile-menu.close').on('click', function(){
	      $('#mobile-navigation-container, #mobile-menu-expanded, #mobile-menu-expanded-second, #mobile-navigation, #menu-upper-lvl').addClass('hidden');
				$('#mobile-navigation-container, #mobile-menu-expanded, #mobile-menu-expanded-second, #mobile-navigation, #menu-upper-lvl').addClass('hidden');
				$('#mobile-menu-expanded-back').remove()
			});
		}( jQuery ) );
  }
}

export default Menu;
